<div class="side-header-wrapper">

  @if (HELPER.loginEnabled) {
    <div class="user-wrapper">
      @if (user) {
        <div class="user-row">
          <div (click)="navigateToProfile()" class="user-profile">
            <app-user-avatar
              [firstName]="user.attributes.given_name"
              [lastName]="user.attributes.family_name"
            ></app-user-avatar>
            <div class="title">{{ userName }}</div>
          </div>
          <div class="logout-btn" (click)="logout()">
            <i class="icon-SignOut"></i>
            <div class="title">{{ 'Log out' | translate }}</div>
          </div>
        </div>
      } @else {
        <div class="no-user">
          <img src="assets/images/no-user.svg" alt="No user photo">
          <span class="description">{{ 'You are not logged in' | translate }}</span>
          <app-button
            [ariaLabel]="'Login' | translate"
            (clicked)="openDialog()" [buttonStyleType]="ButtonTypes.PRIMARY_0" class="login-btn">
            {{ 'Login' | translate }}
          </app-button>
        </div>
      }
    </div>
  }
  <a routerLink="{{frLoc}}/home" routerLinkActive="active" (click)="closeMenu()">
    <div class="tab">
      <span class="text--semi-bold"> {{ 'Home'|translate }} </span>
    </div>
  </a>

  @for (tab of menuItems; track tab.folderId) {
    <a routerLink="{{frLoc}}/{{tab.sourceUrl}}" routerLinkActive="active" (click)="closeMenu()">
      <div class="tab">
        <span class="text--semi-bold"> {{ tab.title }} </span>
      </div>
    </a>
  }
</div>
